import {useEffect, useState, useRef} from 'react';
import {getAllBatches, insertBatch, hideBatch, updateBatchDescription} from "../../api/Api";
import {Button, Table, Checkbox, Input, Row, Card} from 'antd';
import {Link} from "react-router";
import {toFSDate} from "../../util/timeutils";
import {TrashWidget} from "../widget/TrashWidget";
import {TextChangeWidget} from "../widget/TextChangeWidget";
import {getColumnSearchProps} from "../widget/SearchProps";

const {TextArea} = Input;

export const AllBatchView = ({refresh, onRefresh, onApiFail, props}) => {
    const [batches, setBatches] = useState([]);
    const [hidden, setHidden] = useState(false);

    const [batchName, setBatchName] = useState(undefined);
    const [batchDescription, setBatchDescription] = useState("");

    useEffect(() => {
        getAllBatches().then(r => {
            const result = r.map(l => {
                return {
                    ...l,
                    key: l.id
                }
            }).filter(batch => {
                return (batch.deleted === 0) || (hidden === true);
            })
            setBatches(result);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [refresh, onApiFail, hidden]);

    const onDescriptionChange = (record) => (description) => {
        updateBatchDescription(record.id, description).then(r => {
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }

    const onNewDescriptionChange = (e) => {
        setBatchDescription(e.target.value);
    }

    const searchInput = useRef(null);

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (val, record) => {
                return <Link to={`/cultivationapp/batch/${record.id}`}>{val}</Link>
            },
            ...getColumnSearchProps('name', searchInput),
            sorter: (a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            render: (val, record) => {
                let displayVal = (val === null) ? `Enter Description` : val;
                return <TextChangeWidget text={displayVal} maxLength={512} rows={4} onTextSave={onDescriptionChange(record)}/>
            }
        },
        {
            title: 'Created',
            dataIndex: 'created',
            key: 'created',
            render: (val) => {
                return toFSDate(new Date(val));
            },
            sorter: (a, b) => (new Date(a.created))- (new Date(b.created)),
        },
        {
            title: 'Start Time',
            dataIndex: 'startTime',
            key: 'startTime',
            render: (val) => {
                if (val) {
                    return toFSDate(new Date(val));
                } else {
                    return 'None'
                }
            }
        },
        {
            title: 'Harvest Time',
            dataIndex: 'harvestTime',
            key: 'harvestTime',
            render: (val) => {
                if (val) {
                    return toFSDate(new Date(val));
                } else {
                    return 'None'
                }
            }
        },
        {
            title: 'Hide',
            dataIndex: 'deleted',
            key: 'delete',
            render: (val, record, index) => {
                if (hidden === true) {
                    return <Checkbox checked={val} onClick={onHide(record)} />
                } else {
                    return <TrashWidget onDelete={onDelete(record)} />
                }
            }
        }
    ];

    const clearForm = () => {
        setBatchName(undefined);
        setBatchDescription("");
    }

    const hide = (record, hidden) => {
        // delete the batch
        hideBatch(record.id, hidden).then(r => {
            if (onRefresh) {onRefresh()}
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }

    const onDelete = (record) => () => {
        hide(record, 1);
    }

    const onHide = (record) => () => {
        hide(record, record.deleted ? 0 : 1);
    }

    const onNameChange = (e) => {
        setBatchName(e.target.value);
    }

    const onBatchSubmit = () => {
        insertBatch(batchName, batchDescription).then(r => {
            clearForm();
            if (onRefresh) {onRefresh();}
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }

    const onHiddenCheckClick = (e) => {
        setHidden(e.target.checked);
    }

    const rowStyle= {
        margin: '5px',
        width: '500px'
    }

    const cardStyle = {
        textAlign: 'left',
        marginTop: '10px',
        marginBottom: '10px'
    }

    return <div>
        <Card style={cardStyle} title={<b>New Batch</b>}>
            <Row style={rowStyle}><Input onChange={onNameChange} placeholder={'Name'} value={batchName} /></Row>
            <Row style={rowStyle}>
                <TextArea onChange={onNewDescriptionChange} value={batchDescription} rows={4} maxLength={2048} placeholder={'Description'}/>
            </Row>
            <Row style={rowStyle}><Button onClick={onBatchSubmit}>Submit</Button></Row>
        </Card>
        <Card style={cardStyle} title={<b>Batches</b>}>
            <Row style={rowStyle}>
                <Checkbox checked={hidden} onClick={onHiddenCheckClick}><b>Show Hidden</b></Checkbox>
            </Row>
            <Table dataSource={batches} columns={columns} pagination={false} />
        </Card>
    </div>
}